import styled from '@emotion/styled'
import { Divider } from '../../../Divider'
import { Offer } from '../../typings/Offer'
import { Committees } from './components/Committees'
import { FunctionCodes } from './components/FunctionCodes'

interface Props {
  offer: Offer
  type: 'selection' | 'payroll'
}

export const ExpandedRow = ({ offer, type }: Props) => {
  return (
    <Base>
      <Committees offer={offer} />
      <Divider
        orientation="vertical"
        style={{ height: 'auto', marginLeft: 32, marginRight: 32 }}
      />
      <FunctionCodes offer={offer} type={type} />
    </Base>
  )
}

const Base = styled('div')`
  display: flex;
  flex-direction: row;
  @media only screen and (max-width: ${({ theme }) => theme.screenLG - 1}px) {
    flex-direction: column;
  }
`
